import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IError } from "../../interfaces/user/errors";
import { toast } from "react-toastify";
import { AppDispatch } from "../../store";
import { resetAuth } from "../../stores/auth-slice";
import { IForgetFormProps } from "../../interfaces/account/signup";
import { verifyEmail } from "../../data-access/apis/authentication/auth";

const forgetFormProps: IForgetFormProps = {
    email: '',
};

export const ForgetPassHelper = () => {
    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const account = useSelector((state: any) => state.auth);
    const dispatch: AppDispatch = useDispatch();
    const [formErrors, setFormErrors] = useState<IError[]>([]);
    const [values, setValues] = useState<IForgetFormProps>(forgetFormProps);
    const navigate = useNavigate();

    const isFieldEmpty = (field: string) => {
        return field.trim() === '';
    };

    const validateEmail = (email: string): IError | null => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (isFieldEmpty(email)) {
            return { field: 'email', message: 'Please enter your email.' };
        } else if (!emailRegex.test(email)) {
            return { field: 'email', message: 'Please enter a valid email.' };
        }
        return null;
    };

    const handleForgotPassword = async (e: React.FormEvent | any) => {
        e.preventDefault();
        const errors: IError[] = [];

        const emailError = validateEmail(values.email);
        if (emailError) {
            errors.push(emailError);
        }

        setFormErrors(errors);

        if (errors.length > 0) {
            errors.forEach((error) => {
                toast.error(`${error.message}`, {
                    position: 'bottom-right',
                    autoClose: 3000,
                });
            });
            return;
        }

        setIsProcessing(true);

        try {
            if (errors.length === 0) {
                await dispatch(verifyEmail(values));
            }
        } catch (error: any) {
        } finally {
            setIsProcessing(false);
            setValues(forgetFormProps); // Reset the form fields
        }
    };

    // Effect hook to reset state or navigate based on the result
    useEffect(() => {
        if (account.statusCode === 200) {
            setIsProcessing(false);
            setValues(forgetFormProps); // Reset the form fields
            navigate('/auth/verification-account');
            dispatch(resetAuth());
        }
    }, [account.statusCode, navigate, dispatch]);

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setValues((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    return {
        values,
        handleChange,
        formErrors,
        handleForgotPassword,
        account,
        isProcessing,
    };
};